import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PediatricOncologyAndHematologyIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M79.7856 40C79.7856 61.8153 62.1009 79.5 40.2856 79.5C18.4704 79.5 0.785645 61.8153 0.785645 40C0.785645 18.1848 18.4704 0.5 40.2856 0.5C62.1009 0.5 79.7856 18.1848 79.7856 40Z'
      />
      <g clipPath='url(#clip0_414_9853)'>
        <path
          d='M62.9318 47.4636V62.0064C62.9318 62.562 62.4806 63.0132 61.925 63.0132H39.9604C39.4058 63.0132 38.9546 62.562 38.9546 62.0064V47.4636L51.8929 45.1619L62.9308 47.4636H62.9318Z'
          fill='#EAF6FF'
        />
        <path
          d='M49.9766 43.1367L38.9546 54.1587V44.1428C38.9546 43.5874 39.4053 43.1367 39.9606 43.1367H49.9766Z'
          fill='#C4E1FF'
        />
        <path
          d='M62.9306 47.4636V62.0064C62.9306 62.563 62.4804 63.0122 61.9248 63.0122H58.7314C59.2861 63.0122 59.7373 62.563 59.7373 62.0064V46.7976L62.9306 47.4636Z'
          fill='#C4E1FF'
        />
        <path
          d='M62.9307 47.463V44.1428C62.9307 43.5871 62.4803 43.1367 61.9247 43.1367H39.9606C39.405 43.1367 38.9546 43.5871 38.9546 44.1428V47.463H62.9307Z'
          fill='#68DBF9'
        />
        <path
          d='M39.9606 43.1367C39.405 43.1367 38.9546 43.5871 38.9546 44.1428V47.463H45.6501L49.9764 43.1367H39.9606Z'
          fill='#24D1F8'
        />
        <path
          d='M62.931 47.4631V44.1428C62.931 43.5871 62.4806 43.1367 61.9249 43.1367H58.7402C59.2915 43.1415 59.7375 43.5899 59.7375 44.1423V47.4631H62.931Z'
          fill='#24D1F8'
        />
        <path
          d='M44.5263 51.2653H42.5816C42.1648 51.2653 41.8271 50.9275 41.8271 50.5108C41.8271 50.094 42.1649 49.7563 42.5816 49.7563H44.5263C44.9431 49.7563 45.2808 50.0941 45.2808 50.5108C45.2808 50.9276 44.943 51.2653 44.5263 51.2653Z'
          fill='#FB6672'
        />
        <path
          d='M47.3771 55.0424H46.0709C45.6541 55.0424 45.3164 54.7046 45.3164 54.2879C45.3164 53.8711 45.6542 53.5334 46.0709 53.5334H47.3771C47.7939 53.5334 48.1316 53.8712 48.1316 54.2879C48.1317 54.7046 47.7939 55.0424 47.3771 55.0424Z'
          fill='#31A7FB'
        />
        <path
          d='M47.3772 60.5158H42.5816C42.1648 60.5158 41.8271 60.178 41.8271 59.7613C41.8271 59.3445 42.1649 59.0068 42.5816 59.0068H47.3772C47.794 59.0068 48.1317 59.3446 48.1317 59.7613C48.1318 60.178 47.794 60.5158 47.3772 60.5158Z'
          fill='#31A7FB'
        />
        <path
          d='M42.9532 55.0424H42.5816C42.1648 55.0424 41.8271 54.7046 41.8271 54.2879C41.8271 53.8711 42.1649 53.5334 42.5816 53.5334H42.9532C43.37 53.5334 43.7077 53.8712 43.7077 54.2879C43.7077 54.7046 43.37 55.0424 42.9532 55.0424Z'
          fill='#31A7FB'
        />
        <path
          d='M47.3772 57.779H42.5816C42.1648 57.779 41.8271 57.4412 41.8271 57.0245C41.8271 56.6077 42.1649 56.27 42.5816 56.27H47.3772C47.794 56.27 48.1317 56.6078 48.1317 57.0245C48.1318 57.4412 47.794 57.779 47.3772 57.779Z'
          fill='#31A7FB'
        />
        <path
          d='M59.223 53.2414C58.6554 52.4505 57.747 52.0781 56.8626 52.1554C56.4103 52.195 55.9715 52.0006 55.7127 51.6276C55.5405 51.3794 55.3004 51.1708 54.9994 51.0316C54.2808 50.6992 53.409 50.9 52.9089 51.5138C52.6817 51.7926 52.555 52.1128 52.5191 52.4364C52.4978 52.6295 52.3719 52.7931 52.187 52.853C51.8465 52.9631 51.5223 53.1446 51.237 53.4002C50.1885 54.3397 50.0693 55.976 50.9691 57.0589C51.5391 57.7448 52.3818 58.0687 53.2072 58.0055C53.5974 57.9756 53.9673 58.1556 54.2254 58.4497C54.3779 58.6234 54.5684 58.7707 54.7939 58.8787C55.5418 59.2369 56.4596 59.0094 56.9554 58.3449C57.1107 58.1368 57.2126 57.908 57.2651 57.6735C57.3046 57.4965 57.4501 57.3623 57.6278 57.3254C58.0595 57.2358 58.475 57.0358 58.8305 56.7207C59.8233 55.84 59.9967 54.3196 59.223 53.2414Z'
          fill='#FC9AA1'
        />
        <path
          d='M58.8307 56.7206C58.4745 57.0355 58.059 57.2358 57.6274 57.3252C57.4504 57.3624 57.3045 57.4962 57.2652 57.6733C57.2129 57.9077 57.1104 58.1371 56.9554 58.3443C56.4594 59.0093 55.5419 59.2367 54.7934 58.8785C54.568 58.7708 54.3778 58.6229 54.2249 58.4498C54.0801 58.2838 53.9 58.154 53.6997 58.0787C54.2359 58.1159 54.7762 57.8834 55.1102 57.4368C55.253 57.2456 55.3466 57.0354 55.3948 56.8201C55.4311 56.658 55.5648 56.5343 55.7278 56.5011C56.1242 56.4186 56.5065 56.2345 56.8324 55.9448C57.7449 55.1359 57.9039 53.7395 57.1936 52.7496C57.0185 52.5051 56.8072 52.3038 56.5738 52.148C56.6684 52.1611 56.7649 52.1641 56.8626 52.155C57.7469 52.0776 58.6554 52.4508 59.2228 53.2415C59.9967 54.3193 59.8236 55.8404 58.8307 56.7206Z'
          fill='#FB8189'
        />
        <path
          d='M53.2215 55.9082C53.1594 55.9082 53.0962 55.9005 53.0332 55.8843C52.6296 55.7807 52.3865 55.3694 52.4903 54.9658L52.493 54.9551C52.5965 54.5516 53.0076 54.3085 53.4115 54.412C53.8151 54.5157 54.0582 54.9271 53.9544 55.3306L53.9517 55.3413C53.8643 55.6819 53.5576 55.9082 53.2215 55.9082Z'
          fill='#FFC4C8'
        />
        <path
          d='M55.4169 57.1505C55.3526 57.1505 55.2874 57.1422 55.2223 57.1249C54.8196 57.0177 54.58 56.6044 54.6872 56.2017L54.69 56.1909C54.7972 55.7883 55.2106 55.549 55.6132 55.6558C56.016 55.763 56.2554 56.1763 56.1484 56.579L56.1456 56.5898C56.0556 56.9276 55.7505 57.1505 55.4169 57.1505Z'
          fill='#FFC4C8'
        />
        <path
          d='M56.166 52.7768C56.0644 52.7768 55.9612 52.7562 55.8623 52.7126C55.4809 52.5447 55.3079 52.0993 55.4758 51.718L56.1633 50.1569C56.3313 49.7755 56.7767 49.6027 57.1579 49.7703C57.5392 49.9383 57.7123 50.3837 57.5444 50.765L56.8569 52.3261C56.7324 52.6086 56.4559 52.7768 56.166 52.7768Z'
          fill='#FB4A59'
        />
        <path
          d='M52.1548 60.6289C52.0531 60.6289 51.9497 60.6083 51.8507 60.5645C51.4694 60.3965 51.2966 59.951 51.4647 59.5697L52.1633 57.9857C52.3313 57.6045 52.7768 57.4315 53.1581 57.5998C53.5393 57.7678 53.7122 58.2134 53.544 58.5946L52.8455 60.1786C52.7211 60.4609 52.4446 60.6289 52.1548 60.6289Z'
          fill='#FB4A59'
        />
        <path
          d='M52.5207 36.6544V36.6554L26.0162 63.1589C23.5621 65.614 19.5817 65.614 17.1267 63.1589C14.6726 60.7039 14.6726 56.7235 17.1267 54.2694L43.6312 27.7649L49.9436 30.1242L52.5207 36.6544Z'
          fill='#C9F0FD'
        />
        <path
          d='M56.2569 32.9178L26.0166 63.1582C23.5616 65.6131 19.5815 65.6138 17.1265 63.1588C16.7588 62.7911 16.4458 62.3884 16.189 61.9623C18.6055 63.4242 21.7952 63.1111 23.8824 61.024L54.1227 30.7837L56.2569 32.9178Z'
          fill='#9CE6FB'
        />
        <path
          d='M43.6265 27.7676L47.3626 24.0314L56.2509 32.9198L52.5148 36.6559L43.6265 27.7676Z'
          fill='#9CE6FB'
        />
        <path
          d='M53.0335 31.8741L45.9652 38.9412L39.2505 40.4588L36.7222 38.9412L48.4115 27.252L53.0335 31.8741Z'
          fill='#68DBF9'
        />
        <path
          d='M53.0335 31.8731L45.9653 38.9413L40.269 40.2284L50.8285 29.6689L53.0335 31.8731Z'
          fill='#24D1F8'
        />
        <path
          d='M36.7221 38.9414L19.261 56.4025C17.9862 57.6773 17.9869 59.7509 19.261 61.025C20.535 62.2991 22.608 62.2991 23.8828 61.0243L45.9656 38.9415L36.7221 38.9414Z'
          fill='#FC9085'
        />
        <path
          d='M41.5561 38.9414L21.6781 58.8195C20.8024 59.6951 19.5497 59.969 18.4385 59.6418C18.5879 60.1483 18.8617 60.6256 19.2608 61.0247C20.5349 62.2988 22.6079 62.2988 23.8825 61.024L45.9651 38.9415L41.5561 38.9414Z'
          fill='#FC7C6A'
        />
        <path
          d='M45.7598 29.9011L48.4064 27.2545L53.0275 31.8756L50.3809 34.5222L45.7598 29.9011Z'
          fill='#24D1F8'
        />
        <path
          d='M54.2267 33.0663L47.2188 26.0584C46.6992 25.5388 46.6992 24.6963 47.2188 24.1767L49.6775 21.718L55.9107 24.0284L58.5672 30.6076L56.1085 33.0663C55.5888 33.5859 54.7464 33.5859 54.2267 33.0663Z'
          fill='#FB4A59'
        />
        <path
          d='M58.5675 30.608L56.1088 33.0667C55.589 33.5865 54.7459 33.5857 54.2269 33.0667L51.3584 30.1982C51.8774 30.7172 52.7204 30.718 53.2403 30.1982L55.699 27.7395L58.5675 30.608Z'
          fill='#F82F40'
        />
        <path
          d='M58.9627 31.0029L49.2821 21.3224C48.781 20.8213 48.781 20.0088 49.2821 19.5077L53.414 15.3758C53.9151 14.8747 54.7276 14.8747 55.2287 15.3758L64.9093 25.0563C65.4104 25.5574 65.4104 26.3699 64.9093 26.8711L60.7774 31.0029C60.2762 31.5041 59.4638 31.5041 58.9627 31.0029Z'
          fill='#FB6672'
        />
        <path
          d='M64.9094 26.8717L60.7777 31.0034C60.2763 31.5048 59.4633 31.504 58.9628 31.0034L55.9482 27.9888C56.4496 28.4902 57.2618 28.4902 57.7631 27.9888L61.8948 23.8571C62.3962 23.3557 62.3962 22.5436 61.8948 22.0422L64.9094 25.0568C65.4099 25.5574 65.4108 26.3704 64.9094 26.8717Z'
          fill='#FB4A59'
        />
        <path
          d='M55.0348 23.6349C54.8417 23.6349 54.6486 23.5612 54.5012 23.4138C54.2066 23.1192 54.2066 22.6414 54.5013 22.3468L56.2535 20.5947C56.5481 20.3002 57.0259 20.3001 57.3206 20.5948C57.6152 20.8894 57.6152 21.3673 57.3205 21.6619L55.5683 23.4139C55.4211 23.5613 55.2279 23.6349 55.0348 23.6349Z'
          fill='#FB4A59'
        />
        <path
          d='M57.3678 25.9682C57.1748 25.9682 56.9816 25.8944 56.8343 25.7472C56.5396 25.4524 56.5396 24.9747 56.8343 24.68L58.5863 22.9279C58.881 22.6334 59.3588 22.6334 59.6535 22.9279C59.9481 23.2227 59.9481 23.7004 59.6535 23.9951L57.9014 25.7472C57.754 25.8944 57.5608 25.9682 57.3678 25.9682Z'
          fill='#FB4A59'
        />
        <path
          d='M52.7018 21.3019C52.5088 21.3019 52.3156 21.2282 52.1682 21.0809C51.8736 20.7862 51.8736 20.3084 52.1682 20.0137L53.9203 18.2617C54.215 17.9671 54.6927 17.9671 54.9875 18.2617C55.2821 18.5564 55.2821 19.0341 54.9875 19.3289L53.2354 21.0809C53.088 21.2282 52.8948 21.3019 52.7018 21.3019Z'
          fill='#FB4A59'
        />
        <path
          d='M59.7384 28.3386C59.5453 28.3386 59.3522 28.2648 59.2048 28.1175C58.9102 27.8228 58.9102 27.345 59.2049 27.0504L60.9571 25.2983C61.2517 25.0037 61.7295 25.0038 62.0242 25.2984C62.3189 25.593 62.3188 26.0709 62.0241 26.3655L60.2719 28.1176C60.1247 28.2649 59.9315 28.3386 59.7384 28.3386Z'
          fill='#F82F40'
        />
        <path
          d='M23.1116 58.1155C22.9185 58.1155 22.7253 58.0418 22.5781 57.8945L22.391 57.7075C22.0962 57.4128 22.0962 56.9351 22.391 56.6403C22.6856 56.3458 23.1634 56.3458 23.4581 56.6403L23.6452 56.8273C23.9399 57.1221 23.9399 57.5998 23.6452 57.8945C23.4978 58.0418 23.3046 58.1155 23.1116 58.1155Z'
          fill='#C9F0FD'
        />
        <path
          d='M28.2395 52.9874C28.0464 52.9874 27.8533 52.9136 27.706 52.7664L27.5189 52.5793C27.2242 52.2846 27.2242 51.807 27.5189 51.5122C27.8135 51.2176 28.2913 51.2176 28.586 51.5122L28.7731 51.6992C29.0678 51.9939 29.0678 52.4716 28.7731 52.7664C28.6257 52.9137 28.4327 52.9874 28.2395 52.9874Z'
          fill='#C9F0FD'
        />
        <path
          d='M33.3679 47.8592C33.1749 47.8592 32.9817 47.7854 32.8344 47.6382L32.6473 47.4512C32.3526 47.1564 32.3526 46.6787 32.6473 46.384C32.9419 46.0895 33.4198 46.0895 33.7144 46.384L33.9014 46.571C34.1961 46.8657 34.1961 47.3435 33.9014 47.6382C33.7541 47.7854 33.561 47.8592 33.3679 47.8592Z'
          fill='#C9F0FD'
        />
        <path
          d='M38.4958 42.731C38.3027 42.731 38.1095 42.6573 37.9623 42.51L37.7752 42.323C37.4805 42.0283 37.4805 41.5506 37.7752 41.2558C38.0699 40.9613 38.5477 40.9613 38.8423 41.2558L39.0293 41.4428C39.3241 41.7375 39.3241 42.2152 39.0293 42.51C38.882 42.6574 38.6888 42.731 38.4958 42.731Z'
          fill='#C9F0FD'
        />
        <path
          d='M43.6242 37.6029C43.4311 37.6029 43.238 37.5292 43.0906 37.3819L42.9036 37.1948C42.609 36.9001 42.609 36.4224 42.9036 36.1276C43.1983 35.8331 43.676 35.8331 43.9708 36.1276L44.1579 36.3147C44.4525 36.6095 44.4525 37.0872 44.1579 37.3819C44.0104 37.5293 43.8173 37.6029 43.6242 37.6029Z'
          fill='#C9F0FD'
        />
        <path
          d='M48.7521 32.4749C48.5589 32.4749 48.3657 32.4011 48.2184 32.2537L48.0314 32.0666C47.7368 31.7718 47.7369 31.294 48.0317 30.9995C48.3263 30.7049 48.8041 30.7048 49.0988 30.9998L49.2857 31.1868C49.5802 31.4815 49.5801 31.9593 49.2854 32.2539C49.1381 32.4012 48.9451 32.4749 48.7521 32.4749Z'
          fill='#C9F0FD'
        />
      </g>
      <defs>
        <clipPath id='clip0_414_9853'>
          <rect width='50' height='50' fill='white' transform='translate(15.2856 15)' />
        </clipPath>
      </defs>
    </svg>
  )
);
PediatricOncologyAndHematologyIcon.displayName = 'PediatricOncologyAndHematologyIcon';

export default PediatricOncologyAndHematologyIcon;
